// import React from 'react';
// import styled from 'styled-components';

import getFilterWithCol from '../../helpers/getFilterWithCol';

import { createChangeLogSection } from '../../components/FieldChangeLog';

import tests from '../../helpers/tests';
import Types from '../../modules/types';

export const fieldName = ['FieldText', {
  name: 'name',
  rules: [['validation.isRequired']],
}];

// eslint-disable-next-line no-console
console.log(
  'Types',
  Types,
);

export const fieldShippingProvider = ['FieldSelect', {
  name: 'shippingProvider',
  label: 'Shipping Provider',
  disabled: [tests.viewerIsNotAdmin],
  hidden: [tests.viewerIsNotAdmin],
  getInitialValue: (fieldConfig, formProps) => {
    if (formProps?.viewer?.role !== 'ADMIN') {
      return 'STORE';
    }
    return formProps?.data?.shippingProvider || undefined;
  },
  choices: Types.SHIPPING_PROVIDER_LIST
  .filter(({ id }) => (
    [
      'STORE',
      'PACKMAN_SHOP',
      'PACKMAN_RUSH',
      'SELF_PICKUP',
    ].includes(id)
  ))
  .map(({ id, label }) => ({
    value: id,
    label,
  })),
  // col: { xs: 24, lg: 12 },
}];

export const fieldStore = ['FieldConnectionSelect', {
  name: 'store',
  placeholder: 'Select the store',
  url: '/stores/list',
  // getChoiceLabel: choice => choice.data.name,
  searchPaths: ['name'],
  disabled: [tests.activityIsNotCreate],
  virtual: [tests.activityIsNotCreate],
  getInitialValue: (field, props) => (
    props.data?.store
    ? props.data.store
    : !props.viewer
    ? undefined
    : props.viewer.role === 'SELLER'
    ? props.viewer.store
    : undefined
  ),
  hidden: [
    tests.viewerIsNotAdmin,
    [
      'condition.testFieldValue',
      'shippingProvider',
      '!==',
      'STORE',
    ],
  ],
  // col: { xs: 24, lg: 12 },
}];

export const [
  fieldsExportColumns,
  fieldsImportColumns,
] = [
  [
    'exportColumns',
    'Export Sheet',
    // eslint-disable-next-line max-len
    'Configure export sheet columns by composing their values out of data found on the order.',
    [
      ['FieldRadio', {
        name: 'exportFormat',
        label: null,
        initialValue: 'CSV',
        choices: [{
          value: 'CSV',
          label: 'CSV',
        }, {
          value: 'XLSX',
          label: 'XLSX',
        }],
        block: true,
      }],
    ],
    'Add Export Value',
    [
      ['FieldText', {
        name: 'name',
        label: null,
        prefix: 'Column Name:',
        col: { xs: 24, lg: 12 },
      }],
      ['FieldSelect', {
        name: 'separator',
        label: null,
        prefix: 'Separator:',
        placeholder: 'eg. comma "," or dot "."',
        initialValue: 'SPACE',
        choices: Types.SHIPPING_COMPANIES_VALUE_SEPARATOR_LIST.map(item => ({
          value: item.id,
          label: item.label,
        })),
        col: { xs: 24, lg: 12 },
      }],
    ],
    Types.SHIPPING_COMPANIES_EXPORT_VALUES_LIST,
    'Value To Export',
    {
      valuesConfig: {
        head: 'horizontal',
      },
      valueConfig: {
        getCol: (field, props) => {
          const value = props.form?.getFieldValue('value') || '';
          return (
            ![
              'STATIC',
              'DATES_DATE_CREATED',
              'DATES_TODAY',
              'DATES_TOMORROW',
            ].includes(value)
            ? {
                xs: { span: 24, order: undefined },
                lg: { span: 24, order: 0 },
              }
            : {
                xs: { span: 24, order: undefined },
                lg: { span: 12, order: 0 },
              }
          );
        },
      },
      valueExtraFields: [
        ['FieldText', {
          name: 'raw',
          label: null,
          placeholder: 'Value',
          skip: [
            (props) => {
              const value = props.form.getFieldValue('value');
              return ![
                'STATIC',
              ].includes(value);
            },
          ],
          col: {
            xs: { span: 24, order: undefined },
            lg: { span: 12, order: 0 },
          },
        }],
        ['FieldText', {
          name: 'raw',
          label: null,
          prefix: 'Format:',
          placeholder: 'DD-MM-YYYY',
          skip: [
            (props) => {
              const value = props.form.getFieldValue('value');
              return ![
                'DATES_DATE_CREATED',
                'DATES_TODAY',
                'DATES_TOMORROW',
              ].includes(value);
            },
          ],
          col: {
            xs: { span: 24, order: undefined },
            lg: { span: 12, order: 0 },
          },
        }],
        ['FieldText', {
          name: 'valueDivisor',
          label: null,
          prefix: 'Divisor:',
          placeholder: '1',
          skip: [
            (props) => {
              const value = props.form.getFieldValue('value');
              return ![
                'COST_CUSTOMS_VALUE',
              ].includes(value);
            },
          ],
          col: {
            xs: { span: 24, order: undefined },
            lg: { span: 12, order: 0 },
          },
        }],
        ['FieldText', {
          name: 'valueDividedMax',
          label: null,
          prefix: 'Max:',
          placeholder: '1000',
          skip: [
            (props) => {
              const value = props.form.getFieldValue('value');
              return ![
                'COST_CUSTOMS_VALUE',
              ].includes(value);
            },
          ],
          col: {
            xs: { span: 24, order: undefined },
            lg: { span: 12, order: 0 },
          },
        }],
        ['FieldText', {
          name: 'valueIf',
          label: null,
          prefix: 'True:',
          // placeholder: 'Value If',
          skip: [
            (props) => {
              const value = props.form.getFieldValue('value');
              return ![
                'COST_COD_REQUIRED',
                ...Types.PRODUCT_ATTRIBUTE.map(id => `SHIPPING_ITEMS_${id}`),
              ].includes(value);
            },
          ],
          col: {
            xs: { span: 24, order: undefined },
            lg: { span: 12, order: 0 },
          },
        }],
        ['FieldText', {
          name: 'valueElse',
          label: null,
          prefix: 'False:',
          skip: [
            (props) => {
              const value = props.form.getFieldValue('value');
              return ![
                'COST_COD_REQUIRED',
                ...Types.PRODUCT_ATTRIBUTE.map(id => `SHIPPING_ITEMS_${id}`),
              ].includes(value);
            },
          ],
          col: {
            xs: { span: 24, order: undefined },
            lg: { span: 12, order: 0 },
          },
        }],
      ],
    },
  ],
  [
    'importColumns',
    'Import Sheet',
    // eslint-disable-next-line max-len
    'Configure import sheet columns by having their values trigger specific actions on the order during the import.',
    [],
    'Add Import Column',
    [
      ['FieldText', {
        name: 'name',
        label: null,
        prefix: 'Column Name:',
        // col: { xs: 24, lg: 12 },
      }],
      ['FieldText', {
        name: 'prefix',
        label: null,
        prefix: 'Prefix:',
        col: { xs: 24, lg: 12 },
      }],
      ['FieldText', {
        name: 'suffix',
        label: null,
        prefix: 'Suffix:',
        col: { xs: 24, lg: 12 },
      }],
    ],
    Types.SHIPPING_COMPANIES_IMPORT_VALUES_LIST,
    'Column Value Action',
    {
      valuesConfig: {
        head: 'horizontal',
        getItemHead: (value, _props) => {
          if (value?.value === 'ACTION') {
            return 'vertical';
          }
          return 'horizontal';
        },
      },
      valueExtraFields: [
        ['FieldSortableList', {
          name: 'actionValuesMap',
          label: null,
          addButtonLabel: 'Add Action Case',
          // size: 'small',
          condensed: true,
          head: 'horizontal',
          skip: [
            [
              'condition.testFieldValue',
              'value',
              '!==',
              'ACTION',
            ],
          ],
          fields: [
            getFilterWithCol(['FieldText', {
              name: 'value',
              label: null,
              prefix: 'Value:',
              placeholder: 'Column value',
            }], 12),
            getFilterWithCol(['FieldSelect', {
              name: 'action',
              label: null,
              prefix: 'Action:',
              placeholder: 'Action to perform',
              choices: [{
                label: 'Set As Processing',
                value: 'DELIVERY',
              }, {
                label: 'Set As Delivered',
                value: 'DELIVERED',
              }, {
                label: 'Set As Failed',
                value: 'FAILED',
              }, {
                label: 'Skip',
                value: 'SKIP',
              }],
              initialValue: 'DELIVERY',
            }], 12),
          ],
        }],
      ],
    },
  ],
].map(([
  name,
  title,
  subtitle,
  afterTitle = [],
  addButtonLabel,
  fields,
  valuesTypeList,
  valuesTypePlaceholder,
  {
    valueConfig = {},
    valuesConfig = {},
    valueExtraFields = [],
  } = {},
// eslint-disable-next-line arrow-body-style
]) => {
  return [
    ['FieldTitle', {
      title,
      subtitle,
      // size: 'medium',
    }],
    ...afterTitle,
    ['FieldSortableList', {
      name,
      label: null,
      condensed: true,
      addButtonLabel,
      fields: [
        ...fields,
        ['FieldSortableList', {
          name: 'values',
          label: null,
          addButtonLabel: 'Add Parameter',
          // size: 'small',
          condensed: true,
          // head: 'horizontal',
          fields: [
            ['FieldSelect', {
              name: 'value',
              label: null,
              // prefix: valuesTypePrefix,
              placeholder: valuesTypePlaceholder,
              choices: valuesTypeList.map(value => ({
                value: value.id,
                label: value.label,
              })),
              ...valueConfig,
            }],
            ...valueExtraFields,
          ],
          ...valuesConfig,
        }],
      ],
    }],
  ].filter(field => field);
});

// export const fieldExportColumns = ['FieldSortableList', {
//   name: 'exportColumns',
//   label: 'Export Columns',
//   // collapseFieldName: '__collapsed',
//   // collapseLabelDefault: 'Column',
//   fields: [
//     // ['FieldReact', {
//     //   virtual: [() => true],
//     //   label: null,
//     //   renderContent: (props) => (
//     //     <Title>
//     //       {props.form.getFieldValue('name') || 'Column'}
//     //       &nbsp;
//     //     </Title>
//     //   ),
//     // }],
//     ['FieldText', {
//       name: 'name',
//       label: null,
//       prefix: 'Column Name:',
//       col: { xs: 24, lg: 12 },
//     }],
//     ['FieldText', {
//       name: 'separator',
//       label: null,
//       prefix: 'Separate with:',
//       placeholder: 'eg. comma "," or dot "."',
//       col: { xs: 24, lg: 12 },
//     }],
//     ['FieldSortableList', {
//       name: 'values',
//       label: null,
//       addButtonLabel: 'Add Value',
//       // size: 'small',
//       condensed: true,
//       fields: [
//         ['FieldSelect', {
//           name: 'value',
//           label: null,
//           prefix: 'Value:',
//           choices: Types.SHIPPING_COMPANIES_EXPORT_VALUES_LIST.map(value => ({
//             value: value.id,
//             label: value.label,
//           })),
//         }],
//       ],
//     }],
//   ],
// }];

// export const fieldImportColumns = ['FieldSortableList', {
//   name: 'importColumns',
//   label: 'Import Columns',
//   // collapseFieldName: '__collapsed',
//   // collapseLabelDefault: 'Column',
//   fields: [
//     ['FieldReact', {
//       virtual: [() => true],
//       label: null,
//       renderContent: (props) => (
//         <Title>
//           {props.form.getFieldValue('name') || 'Column'}
//           &nbsp;
//         </Title>
//       ),
//     }],
//     ['FieldText', {
//       name: 'name',
//       label: null,
//       prefix: 'Column Name:',
//       // col: { xs: 24, lg: 12 },
//     }],
//     ['FieldSelect', {
//       name: 'value',
//       label: null,
//       prefix: 'Value:',
//       choices: Types.SHIPPING_COMPANIES_IMPORT_VALUES_LIST.map(value => ({
//         value: value.id,
//         label: value.label,
//       })),
//     }],
//   ],
// }];

export const ADMIN = [
  fieldName,
  fieldShippingProvider,
  fieldStore,
  ...fieldsExportColumns,
  ...fieldsImportColumns,
  ...createChangeLogSection({
    changeLogConfig: {
      getWhereConditions: props => ({
        store: { EQ: null },
        'target.type': 'ShippingCompany',
        'target.subject': props.data._id,
      }),
      skipColumns: {
        store: true,
        realm: true,
        target: true,
      },
    },
  }),
];
